import { alpha, Box, Button, Card, Divider, IconButton, Stack, StackProps, SvgIcon, Typography, useTheme } from '@mui/material';

import { DeleteSvgIcon, DocumentExcelIcon, PDFIcon } from '../../assets/index';
import { bytesToMB } from '../../utils';

interface ISingleFilePreviewType extends StackProps {
  file: File;
  onDelete?: () => void;
  error?: boolean;
  helperText?: string;
}

const SingleFilePreview = ({ file, onDelete, error, helperText, ...other }: ISingleFilePreviewType) => {
  const theme = useTheme();

  return (
    <Stack gap={3}>
      <Card component={Box} px={2} py={2} gap={2} alignItems="start">
        <Stack direction={'row'} justifyContent="space-between" alignItems="center" {...other}>
          <Stack direction="row" gap={2}>
            <Box sx={{ borderRadius: 1, bgcolor: alpha(theme.palette.grey[500], 0.08), p: 12 / 8, height: 44, width: 44 }}>
              {other?.showPdfIcon ? <PDFIcon /> : <DocumentExcelIcon />}
            </Box>

            <Stack>
              <Typography variant="subtitle1" name="fileName">
                {file.name}
              </Typography>
              <Typography variant="caption" name="fileSize">
                {bytesToMB(file.size)} MB
              </Typography>
            </Stack>
          </Stack>

          <Stack direction="row" spacing={1} alignItems="center">
            {other?.showPreview && (
              <Button variant="soft" color="primary" size="small" sx={{ mr: 1 }} onClick={other?.onPreview}>
                Preview
              </Button>
            )}
            <Divider orientation="vertical" variant="middle" flexItem />
            <IconButton onClick={onDelete}>
              <SvgIcon>
                <DeleteSvgIcon />
              </SvgIcon>
            </IconButton>
          </Stack>
        </Stack>
        {/* 
        {true && (
          <Stack mt={2}>
            <LinearProgressWithLabel value={50} />
          </Stack>
        )} */}
      </Card>
    </Stack>
  );
};

export default SingleFilePreview;
